import { styled } from 'styled-components'

export const Root = styled.div`
  background-color: #ffffffcc;
  border-radius: 50px;
  padding: 20px;
`

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #35424A;
  text-align: center;
  margin-bottom: 20px;
`

export const Template = styled.div`
  font-size: 16px;
  color: #35424A;
  padding: 20px;
  border-radius: 30px;
  background-color: #d6d7d859;
`

export const Input = styled.input`
  border: none;
  background: transparent;
  font-size: 16px;
  color: #35424A;
`
